import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Printer from 'components/svgs/icons/printer';

export default class PrintLink extends Component {
  static printPage(e) {
    e.preventDefault();
    e.stopPropagation();

    window.print();
  }

  render() {
    const { label, labelId } = this.props;
    return (
      <a href="#" className={`btn-deco-doc text-size-12 align-right hidden-print ${this.props.classNames}`} onClick={this.constructor.printPage}>
        <Printer />
        <FormattedMessage id={labelId} defaultMessage={label} />
      </a>
    );
  }
}

PrintLink.propTypes = {
  label: PropTypes.string,
  labelId: PropTypes.string,
  classNames: PropTypes.string,
};

PrintLink.defaultProps = {
  label: 'Print',
  labelId: 'common.print',
  classNames: '',
};

